import { render } from "./signature.vue?vue&type=template&id=820b7aa2"
import script from "./signature.vue?vue&type=script&lang=js"
export * from "./signature.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/input-only/signature.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "820b7aa2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('820b7aa2', __exports__)) {
    console.log('reload')
    api.reload('820b7aa2', __exports__)
  }
  
  module.hot.accept("./signature.vue?vue&type=template&id=820b7aa2", () => {
    console.log('re-render')
    api.rerender('820b7aa2', render)
  })

}


export default __exports__